import ExamDetails from '../../components/courses/examDetails/[id]';

const ExamDetailsPage = () => {
  return <ExamDetails />;
};

export default ExamDetailsPage;
